/** ⌘K customer search helpers. Hits the existing list endpoint; no new backend. */

export interface PaletteHit {
  id: string;
  label: string;
  href: string;
  keywords: string[];
  hint?: string;
}

export interface CustomerSearchRow {
  id: string;
  name: string;
  risk?: { level: string };
  behavior?: { label: string };
}

/** pageSize must be 25, 50 or 100 (desk-routes). */
export function customersSearchPath(q: string, pageSize: 25 | 50 | 100 = 25): string {
  const search = new URLSearchParams({
    page: '1',
    pageSize: String(pageSize),
    sort: 'name',
    desc: '0',
    q: q.trim().slice(0, 200),
  });
  return `/app-api/customers?${search}`;
}

export function customerPaletteHits(rows: readonly CustomerSearchRow[]): PaletteHit[] {
  return rows.map(row => {
    const hint = row.behavior?.label || (row.risk?.level ? `${row.risk.level} attention` : '');
    return {
      id: `customer:${row.id}`,
      label: row.name,
      href: `customers/${encodeURIComponent(row.id)}`,
      keywords: [row.name, row.id, row.behavior?.label ?? '', row.risk?.level ?? ''].filter(Boolean),
      ...(hint ? { hint } : {}),
    };
  });
}

/** Client filter for static palette pages when cmdk filtering is off (async customer results). */
export function filterByQuery<T extends { label: string; keywords: readonly string[] }>(
  items: readonly T[],
  q: string,
): T[] {
  const needle = q.trim().toLowerCase();
  if (!needle) return [...items];
  return items.filter(item =>
    item.label.toLowerCase().includes(needle)
    || item.keywords.some(k => k.toLowerCase().includes(needle)));
}

/** Debounce delay for live customer search in the palette. */
export const paletteSearchDebounceMs = 220;
/** Avoid hitting the API for one-letter noise. */
export const paletteSearchMinChars = 2;
